module.exports = __webpack_public_path__ + "static/img/foundwinner.d11b6be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/foundwinner.png
// module id = IKY1
// module chunks = 1